// src/components/BrandingColorPicker.js
//
// A labeled grid of swatches for picking one branding color slot
// (primary or accent). Used twice in AdminAppSettings.js's Branding
// card -- once per slot, sharing the same palette (see
// src/constants/brandingColors.js for why one shared palette rather
// than two separate ones).

import React from 'react';
import { BRANDING_COLORS } from '../constants/brandingColors';

function BrandingColorPicker({ label, value, onChange, disabledHex }) {
    return (
        <div>
            <label className="block text-white font-bold text-sm mb-2">{label}</label>
            <div className="grid grid-cols-7 gap-2">
                {BRANDING_COLORS.map(color => {
                    const isSelected = value === color.hex;
                    const isDisabled = disabledHex === color.hex;
                    return (
                        <button
                            key={color.hex}
                            type="button"
                            title={isDisabled ? `${color.name} — already used by the other slot` : color.name}
                            disabled={isDisabled}
                            onClick={() => onChange(color.hex)}
                            className={
                                'aspect-square rounded-lg transition-all ' +
                                (isSelected
                                    ? 'ring-2 ring-offset-2 ring-offset-gray-900 ring-white scale-105'
                                    : 'hover:scale-105') +
                                (isDisabled ? ' opacity-25 cursor-not-allowed hover:scale-100' : '')
                            }
                            style={{ backgroundColor: color.hex }}
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default BrandingColorPicker;
